import { post } from '@/utils/request'

/**
 * 消息会话列表（tab）
 */
export function message_session_list() {
  return post('message_session_list')
}

/**
 * 消息列表
 * @param {String} msg_session_id 会话id
 * @param {String} order_type 排序方式 1为倒序 0为正序
 * @param {String} page 页码
 * @param {String} pagesize 页面大小
 */
export function message_session_detail(data) {
  return post('message_session_detail', data)
}

/**
 * 未读消息总计数 
 * @param {String} tsid	tsid 
 * @param {String} csid	csid 
 */
export function message_session_unread(data) {
  return post('message_session_unread', data)
}

/**
 * 淘客查看通知列表 
 * @param {String} tsid	tsid 
 */
export function taoke_public_notice_list(data) {
  return post('taoke_public_notice_list', data)
}

/**
 * 淘客群发站内信息记录列表 
 * @param {String} tsid	tsid 
 * @param {String} page 页码
 * @param {String} num 页数（不填默认20）
 */
export function taoke_message_list(data) {
  return post('taoke_message_list', data)
}

/**
 * 淘客群发站内信息记录列表 
 * @param {String} tsid	tsid 
 * @param {String} title 标题
 * @param {String} content 发送内容
 * @param {String} url 链接
 * @param {String} send_time 发送时间
 */
export function taoke_message_send(data) {
  return post('taoke_message_send', data)
}

